import React from 'react';
import { ReferenceArrayInput, useQuery, Loading } from 'react-admin';
import { Grid } from '@material-ui/core/';
import { find } from 'lodash';

import GridInputFilter from '../../core/components/inputs/GridInputFilter';
import { makeStyles } from '@material-ui/core';

const validateInvestors = (value, allValues, props, field) => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Investor must be selected';
  }
  return undefined;
};

const validateFunds = (value, allValues, props, field) => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Fund must be selected';
  }
  return undefined;
};

const useStyles = makeStyles({
  loading: {
    height: 'calc(100vh - 230px)'
  }
});

const FundInvestorSummary = props => {
  const classes = useStyles();
  let { data, loading } = useQuery({
    type: 'getManyReference',
    resource: 'fundinvestors',
    payload: {
      target: `${props.fundId ? 'fundId' : 'investorId'}`,
      id: props.fundId ? props.fundId : props.investorId,
      sort: {
        order: 'ASC'
      }
    }
  });
  if (loading) return <Loading className={classes.loading} />;
  const filter = choices => {
    return choices.filter(
      item =>
        find(data, [`${props.fundId ? 'investorId' : 'fundId'}`, item.id]) ===
        undefined
    );
  };

  const ReferenceArrayInputProps = {
    label: `${
      props.fundId
        ? 'To add Investor to this Fund, select one or multiple items from the list of the Investor below.'
        : 'To add Fund to this Investor, select one or multiple items from the list of the Funds below.'
    }`,
    optionTextLabel: `${props.fundId ? 'Investor Name' : 'Fund Name'}`,
    optionValueLabel: `${props.fundId ? 'Investor ID' : 'Fund ID'}`,
    additionalColumns: [
      { label: 'Status', name: 'status', isStatusColumn: true }
    ],
    resource: `${props.fundId ? 'investors' : 'funds'}`,
    reference: `${props.fundId ? 'investors' : 'funds'}`,
    source: `${props.fundId ? 'investors' : 'funds'}`
  };

  return (
    <div>
      <Grid container spacing={1}>
        <ReferenceArrayInput
          perPage={-1}
          sort={{ field: 'name', order: 'ASC' }}
          validate={[props.fundId ? validateInvestors : validateFunds]}
          filter={props.fundId && { orphanVisibility: 'ALL_VISIBLE' }}
          {...ReferenceArrayInputProps}
        >
          <GridInputFilter
            choicesToExclude={data}
            filterOptionValue={`${props.fundId ? 'investorId' : 'fundId'}`}
            filter={filter}
            height={'calc(100vh - 335px)'}
          />
        </ReferenceArrayInput>
      </Grid>
    </div>
  );
};

export default FundInvestorSummary;
